import httpRequest from './httpRequest'

export default () => {
  window.addEventListener('load', () => {
    if (performance === undefined) {
      console.log('performance NOT supported')
      return
    }

    setTimeout(() => {
      const resources = performance.getEntriesByType('resource')
      if (resources === undefined || resources.length <= 0) {
        console.log('there are NO `resource` performance records')
        return
      }

      const fetchResources = resources
        .filter(r => r.initiatorType === 'xmlhttprequest' || r.initiatorType === 'fetch')
        .map(r => ({
          connectEnd: r.connectEnd,
          connectStart: r.connectStart,
          decodedBodySize: r.decodedBodySize,
          domainLookupEnd: r.domainLookupEnd,
          domainLookupStart: r.domainLookupStart,
          duration: r.duration,
          encodedBodySize: r.encodedBodySize,
          entryType: r.entryType,
          fetchStart: r.fetchStart,
          initiatorType: r.initiatorType,
          name: r.name,
          nextHopProtocol: r.nextHopProtocol,
          redirectEnd: r.redirectEnd,
          redirectStart: r.redirectStart,
          requestStart: r.requestStart,
          responseEnd: r.responseEnd,
          responseStart: r.responseStart,
          secureConnectionStart: r.secureConnectionStart,
          serverTiming: r.serverTiming,
          startTime: r.startTime,
          transferSize: r.transferSize,
          workerStart: r.workerStart,
          page: window.location.pathname,
        }))

      const pageResources = performance.getEntriesByType('navigation')
      const metrics = {
        metrics: fetchResources.concat(pageResources),
      }

      httpRequest.collectMetrics(metrics)
    }, 5000)
  })
}
